import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Artifact } from '../../models/artifact.model';

/**
 * Renders an artifact whose report is a self-contained, URL-addressable document
 * (NEAT's styled HTML report; any future PDF/HTML report). Embeds `fileUrl` in a
 * sandboxed iframe so the report renders with its own styling — no need to ship
 * the report's CSS into the app. Registered under types 'document' | 'html' |
 * 'pdf' in ARTIFACT_RENDERERS. Open/download live in the panel header.
 */
@Component({
  selector: 'app-document-artifact',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (safeUrl) {
      <iframe class="doc-frame" [src]="safeUrl" title="Report preview"
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
        referrerpolicy="no-referrer"></iframe>
    } @else {
      <p class="doc-empty">This report can't be previewed here. Use Open in new tab or Download above.</p>
    }
  `,
  styleUrls: ['./document-artifact.component.scss'],
})
export class DocumentArtifactComponent {
  private _url?: string;
  safeUrl?: SafeResourceUrl;
  private readonly sanitizer = inject(DomSanitizer);

  @Input() set artifact(a: Artifact) {
    if (a?.fileUrl && a.fileUrl !== this._url) {
      this._url = a.fileUrl;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(a.fileUrl);
    }
  }
}
